import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../../../../img/caretDownGeneric.svg'
import { taxonomyLevel1Values } from './taxonomyLevel1Values'

import Tooltip from '@mui/material/Tooltip';
import infoIcon from '../../../../../images/circle-info-regular-full.svg';


function Taxonomy1 ({ localTaxonomyLevel1, setLocalTaxonomyLevel1 }) {
  const handleTaxonomyChange = event => {
    setLocalTaxonomyLevel1(event.target.value.toLowerCase())
  }

  return (
    <div className={styles.taxonomy1InputWrapper}>
      <div className={styles.inlineLabel}>
        <label className={styles.taxonomy1Label}>Taxonomy (level 1)</label>
        <Tooltip
          title='Filter by top-level product taxonomy. Select a category to narrow results, or leave as Any to include all.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Taxonomy (level 1) help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div>
        <select
          className={styles.taxonomy1DropBox}
          name='taxonomy'
          id='taxonomy'
          value={localTaxonomyLevel1}
          onChange={handleTaxonomyChange}
        >
          <option value=''>Any</option>
          {taxonomyLevel1Values.map((category, index) => (
            <option key={index} value={category.toLowerCase()}>
              {category}
            </option>
          ))}
        </select>
        <img
          src={caretDown}
          alt='arrow'
          className={styles.taxonomy1CustomArrow}
        />
      </div>
    </div>
  )
}

export default Taxonomy1
